import { generateUtilityClasses } from '../../utils';

export const listPageSkeletonClasses = generateUtilityClasses('ListPageSkeleton', [
  'root',
  'header',
  'dataTable',
]);
